export const ROUTES = {
    PROJECTS: 'projects',
    EXPLORE: 'explore',
    CONTACT: 'contact',
    STUDIO: 'studio',
    CREW: 'crew',
};
